<template>
  <div class="wrapper">
    <button v-if="isMobile" class="toggle-button" @click="toggle">
      <img class="hamburger-button" src="../assets/hamburger.svg" alt="">
    </button>
    <transition name="slide-fade">
      <div v-if="show" :class="`menu ${isMobile ? 'mobile' : 'not-mobile'}`">
        <h3 class="logo">
          <router-link class="link" to="/">
            <span @click="toggle" class="namesake">Lê Xuân Phong</span>
          </router-link>
        </h3>

        <!-- PROJECTS -->
        <p @click="showProjects = !showProjects" class="header">
          <span class="header-text">PROJECTS</span>
        </p>
        <div v-if="showProjects" class="sub-menu">
          <router-link v-for="(album, i) in filteredAlbums('projects')" :key="i" class="link" :to="`/${album.album.toLowerCase().replace(/ /g, '')}`">
            {{ album.album }}
          </router-link>
        </div>

        <!-- COMMISSIONS -->
        <p @click="showCommissions = !showCommissions" class="header">
          <span class="header-text">COMMISSIONS</span>
        </p>
        <div v-if="showCommissions" class="sub-menu">
          <router-link v-for="(album, i) in filteredAlbums('commissions')" :key="i" class="link" :to="`/${album.album.toLowerCase().replace(/ /g, '')}`">
            {{ album.album }}
          </router-link>
        </div>

        <!-- ABOUT -->
        <p>
          <router-link to="about" class="link">
            <span @click="toggle" class="header">ABOUT</span>
          </router-link>
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import { isMobile, PhotoLibrary } from '@/scripts';

@Component
export default class Menu extends Vue {
  library = PhotoLibrary;
  isMobile = isMobile;
  show = true;
  showProjects = true;
  showCommissions = true;

  toggle() {
    if (this.isMobile) {
      this.show = !this.show;
    }
  }

  filteredAlbums(catalog) {
    return this.library.filter(album => album.catalog.toLowerCase() === catalog);
  }
}
</script>

<style lang="css" scoped>
.wrapper {
  position: fixed;
  z-index: 30;
}

.hamburger-button {
  height: 40px;
  width: auto;
  border: 3px solid #fff;
  border-radius: 50%;
  background: white;
}

.toggle-button {
  position: fixed;
  z-index: 50;
  margin: 10px;
}

.menu {
  text-align: right; /* Adjusted alignment to left */
  height: calc(100% - 50px);
  width: 240px; /* Increased width for better spacing */
  background-color: white;
  position: fixed;
  left: 0;
  top: 0; /* Adjusted top position */
  bottom: 0; /* Adjusted bottom position */
  z-index: 30;
  padding: 80px 20px 20px; /* Adjusted padding */
  transition: all 0.2s ease-in-out;
}

.menu.mobile {
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
}

.menu.not-mobile {
  opacity: .5;
}

.menu.not-mobile:hover {
  opacity: 1;
}

.namesake {
  font-family: Archivo Black,Arial,sans-serif;
  font-weight: 800;
  font-size: 24px
}

.logo {
  margin-bottom: 40px; /* Reduced margin */
}

.menu:hover {
  opacity: 1;
}

.header {
  font-size: 18px; /* Increased font size */
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  margin-bottom: 20px; /* Increased margin */
  color: #000000; /* Adjusted font color */
  white-space: pre-line;
}

.header-text {
  font-weight: bold;
}

.sub-menu {
  padding-left: 20px;
}

.link {
  color: #333; /* Adjusted font color */
  text-decoration: none;
  font-style: italic;
  transition: all 0.1s ease-in-out;
  display: block;
  margin-bottom: 8px; /* Increased margin */
  font-size: 14px; /* Increased font size */
}

.link:hover {
  color: #ff7f7f; /* Changed hover color to red */
}
</style>